// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
export const CUSTOMER_FIELDS = {
  name: 'name',
  code: 'code',
  ordersAmount: 'ordersAmount',
  jobRequestsAmount: 'jobRequestsAmount',
  assetsAmount: 'assetsAmount',
  customerUsersAmount: 'customerUsersAmount',
  id: 'id',
  isBlocked: 'isBlocked',
  isActive: 'isActive'
};

export const CUSTOMER_USER_FIELDS = {
  fullName: 'fullName',
  email: 'email',
  title: 'title',
  profilePhoto: 'profilePhoto',
  isBlocked: 'isBlocked',
  isActive: 'isActive',
  id: 'id',
  lastActivityDate: 'lastActivityDate',
  profileStatus: 'profileStatus'
};